import { render, staticRenderFns } from "./QuotationProposalAwaitingMessage.vue?vue&type=template&id=3e047c4e"
import script from "./QuotationProposalAwaitingMessage.vue?vue&type=script&lang=js"
export * from "./QuotationProposalAwaitingMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports